import { useTranslation } from 'react-i18next';

export function useErrorBoundaryTranslations() {
  const { t } = useTranslation('translation', { keyPrefix: 'errorBoundary' });

  return {
    title: t('title'),
  };
}
